import { withStyles, Theme } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";

const SpocAccordion = withStyles((theme: Theme) => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      transition: "display 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
      // borderRadius: "0px 0px 10px 10px",
      "&:before": {
        content: '""',
        display: "block",
        backgroundColor: theme.palette.primary.main,
        height: 8,
        left: -1,
        right: -1,
        top: -1,
        position: "absolute",
        opacity: 1,
        borderRadius: "10px 10px 0px 0px",
        transition: "display 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      },
    },
  },
  expanded: {},
}))(MuiAccordion);

export default SpocAccordion;
